import { Button, Upload } from "antd";
import { BasicDataTable } from "./BasicDataTable";
import { YhBox } from "@src/components/YhBox";
import { baseInfoModel } from "../baseInfoModel";
import { globalPrompt } from "@src/components/YhMessage";
import { importPropsConfig } from "@src/utils/importFile";
import useNavModel from "@src/model/navModel";
import useGlobalModel from "@src/model/globalModel";

export const BasicDataBox: React.FC = () => {
  const { selectedRowKeys, exportData, downloadTpl } = baseInfoModel();
  const { addNav } = useNavModel();
  const { user } = useGlobalModel();

  const onEdit = () => {
    if (selectedRowKeys.length !== 1) {
      globalPrompt("message", { text: "请选择数据！", type: "warning" });
      return;
    }
    addNav("portal-03-04-02", { id: selectedRowKeys[0], mode: "edit", activeKey: "1" })
  }

  const upLoadCallback = (retData: any) => {
  }

  const action = (
    <>
      <Button className="mr-5" type="link" shape="round" onClick={() => { addNav('portal-03-04-01', { id: "", mode: "add", activeKey: "1" }) }}>新增</Button>
      <Button className="mr-5" type="link" shape="round" onClick={() => onEdit()}>编辑</Button>
      <Button className="mr-5" type="link" shape="round" onClick={() => downloadTpl()}>下载模板</Button>
      <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig("/auth/user/list/import", upLoadCallback, { createUser: user.userName || "" })}>
        <Button className="mr-5" type="link" shape="round">导入</Button>
      </Upload>
      <Button className="mr-5" type="link" shape="round" onClick={() => exportData()}>导出</Button>
    </>
  );

  return (
    <YhBox action={action} style={{ height: 'calc(100vh - 230px)' }}>
      <BasicDataTable />
    </YhBox>
  );
}